import { Controller } from "@hotwired/stimulus"

// ケンオール API を使って、住所を埋める。
// https://kenall.jp/docs/API/postalcode/forward-lookup/
export default class extends Controller {
  static targets = ["postalCode", "prefectureCode", "city", "line1"]
  static values = {
    token: String,
  }

  execute() {
    this.call(this.postalCodeTarget.value)
      .then((res) => {
        if (res) this.applyResponse(res)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  applyResponse({ prefectureCode, city }) {
    if (prefectureCode) {
      this.prefectureCodeTarget.value = prefectureCode
    }
    if (city) {
      this.cityTarget.value = city
      this.line1Target.focus()
    }
  }

  async call(postalCode) {
    const res = await fetch(`https://api.kenall.jp/v1/postalcode/${postalCode}`, {
      headers: { Authorization: `Token ${this.tokenValue}` },
    })
    const data = await res.json()
    if (data.data.length == 0) {
      return null
    }
    const address = data.data[0]
    return {
      prefectureCode: address.jisx0402.substring(0, 2),
      city: `${address.city}${address.town}`,
    }
  }
}
